// FairwayBid: Welche Abschnitte der Startseite laufen als Laufband?
//
// Zwei Wege, damit Tom das ohne Code steuern kann:
//   1. Anchor-ID endet auf "-laufband"  -> immer Laufband.
//   2. Ein Spalten-Abschnitt mit vielen  -> ab MIN_BLOCKS automatisch,
//      Kacheln                              weil er sonst umbricht.
// Ein Abschnitt kann mit der Endung "-statisch" ausgenommen werden.

export const MARQUEE_SUFFIX = '-laufband';
export const STATIC_SUFFIX = '-statisch';
export const MIN_BLOCKS = 4;
export const MARQUEE_TYPE = 'fwb-laufband';

export const shouldRunAsMarquee = section => {
  const id = section?.sectionId || '';
  if (id.endsWith(STATIC_SUFFIX)) {
    return false;
  }
  if (id.endsWith(MARQUEE_SUFFIX)) {
    return true;
  }
  const blockCount = section?.blocks?.length || 0;
  return section?.sectionType === 'columns' && blockCount >= MIN_BLOCKS;
};

export const withMarqueeSections = (sections = []) =>
  sections.map(section =>
    shouldRunAsMarquee(section) ? { ...section, sectionType: MARQUEE_TYPE } : section
  );
